export default __webpack_public_path__ + "static/media/border-rounded-linea1.b5bcc39c.svg";